module.exports = __webpack_public_path__ + "static/media/check-circle.8574ce51.svg";